// Holds a body scroll lock (utils/scroll-lock) while `active`, and releases it when it
// turns inactive or unmounts. Renders nothing.
//
// Every commit where `active` is set (mount and changes) also rewrites the body overflow
// from the lock count, which undoes @drawbotics/modal's own write (see components/Modal).
// That only works if this effect runs after the library's in the same commit: React runs
// passive effects depth first, a component's children before the component itself and
// siblings in order, so render ScrollLock as a later sibling (or an ancestor) of the
// library modal, never inside it.
import { useEffect } from 'react';

import { lockScroll, syncScrollLock, unlockScroll } from '~/utils/scroll-lock';


const ScrollLock = ({ active }) => {
  useEffect(() => {
    if (active) {
      lockScroll();
      return unlockScroll;
    }
    syncScrollLock();
  }, [active]);

  return null;
};


export default ScrollLock;
